import { Directive, HostBinding, Input } from '@angular/core';
import { SiteCountry } from '../../models/response-models/site';

export const RTLCountries = [
  'Saudi Arabia'
];

@Directive({
  selector: '[appCountryRtl]'
})
export class CountryRtlDirective {

  @Input() appCountryRtl: SiteCountry;

  @HostBinding('class.rtl') get rtl() {
    return this.appCountryRtl && RTLCountries.includes(this.appCountryRtl.name)
  }

  constructor() { }

}
